import { defineMessages } from 'react-intl';

const messages = defineMessages({
  bulkUpdateHeaderDrawer: {
    defaultMessage: 'Bulk Update',
    description: 'orderDrawer.bulkUpdate.update',
    id: 'F4ODiO',
  },
  bulkUpdateDrawerMainButton: {
    defaultMessage: 'Update',
    description: 'orderDrawer.bulkUpdate.updateButton',
    id: 'LkjwnT',
  },
  bulkUpdateCloseButtonTitle: {
    defaultMessage: 'Close button',
    description: 'Close button title in bulk update drawer',
    id: 'ZXV7j8',
  },
  bulkUpdateLoadingTitle: {
    defaultMessage: 'Loading bulk action content',
    description: 'Title for loading indicator in bulk update drawer',
    id: 'OvXXYQ',
  },
});

export default messages;
